export type SourceNetwork = 'instagram' | 'twitter' | 'tiktok' | 'custom' | 'default';
export const SOURCE_NETWORKS: SourceNetwork[] = ['instagram', 'tiktok', 'custom'];
